// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  defaultTheme: 'nfl',
  production: false,
  amplifyEnv: 'dev',
  serviceEnv: 'dev',
  stageBucket: 'lsb-dev-clubs-stage-zone',
  domain: 'https://lsb-compliance-dev.dna.nfl.net',
  region: 'us-east-1',
  auth: {
    hostname: 'lsb-dev-login.auth.us-east-1.amazoncognito.com',
    redirect_uri: ['https://lsb-compliance-dev.dna.nfl.net/login'],
    response_type: 'code',
    client_id: '2q6jriigbuv3i11a2ade2hjlfm',
    scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    user_pool_id: 'us-east-1_ZosulRHkO',
    identity_pool_id: 'us-east-1:cbe1944a-ea38-4e90-bdb9-8047c2bf4fbc',
    domain: 'lsb-compliance-dev.dna.nfl.net',
  },
  api: {
    aws_appsync_graphqlEndpoint: 'https://lsb-compliance-dev.dna.nfl.net/graphql',
    aws_appsync_region: 'us-east-1',
    aws_appsync_authenticationType: 'userPool',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
